module.exports = __webpack_public_path__ + "static/media/DSM_MasterLogo.0a933545.png";